// Active deals: one compact row of stage counts over the stage sections. Each chip jumps to its section.
// Chip colours are the StagePill palette (lib/stages.ts); empty stages stay quiet.
import { stageAbbr, stageTone } from "../lib/stages";
import type { StageSection } from "../lib/stageGroups";
import { useIsDark } from "../lib/prefs";
import { cx } from "./ui";

export function StageStrip<T>({ sections, onJump, stale, onRegroup }: { sections: StageSection<T>[]; onJump: (key: string) => void; stale: boolean; onRegroup: () => void }) {
  const dark = useIsDark();
  return (
    <nav
      aria-label="Loans by stage"
      className="-mx-4 flex items-center gap-1 overflow-x-auto px-4 [scrollbar-width:none] md:mx-0 md:flex-wrap md:overflow-visible md:px-0 [&::-webkit-scrollbar]:hidden"
    >
      {sections.map((s) => {
        const tone = s.stage ? stageTone(s.stage, dark) : null;
        const n = s.items.length;
        return (
          <button
            key={s.key}
            onClick={() => onJump(s.key)}
            title={`${s.stage ? `${s.stage.sort}. ` : ""}${s.label}: ${n} loan${n === 1 ? "" : "s"}`}
            aria-label={`${s.label}, ${n} loan${n === 1 ? "" : "s"}`}
            className={cx(
              "focus-ring inline-flex h-7 shrink-0 items-center gap-1.5 rounded-md px-2 text-[12px] font-semibold whitespace-nowrap",
              n === 0 && "border border-subtle bg-surface text-ink-3",
              n > 0 && !tone && "border border-dashed border-line bg-surface text-ink",
            )}
            style={n > 0 && tone ? { background: tone.solid, color: tone.on, boxShadow: dark ? undefined : "inset 0 0 0 1px rgb(20 32 46 / .18)" } : undefined}
          >
            <span>{s.stage ? stageAbbr(s.stage) : s.label}</span>
            <span className={cx("tnum", n === 0 ? "font-medium" : "font-bold")}>{n}</span>
          </button>
        );
      })}
      {stale ? (
        <button onClick={onRegroup} className="focus-ring ml-1 shrink-0 rounded-md px-2 py-1 text-[12px] font-medium whitespace-nowrap text-link hover:underline">
          Stages changed · regroup
        </button>
      ) : null}
    </nav>
  );
}
